import { render, staticRenderFns } from "./AddClientModal.vue?vue&type=template&id=3a67c294&scoped=true"
import script from "./AddClientModal.vue?vue&type=script&lang=js"
export * from "./AddClientModal.vue?vue&type=script&lang=js"
import style0 from "./AddClientModal.vue?vue&type=style&index=0&id=3a67c294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67c294",
  null
  
)

export default component.exports